/** Query key for opening a lead from global search. */
export const OPEN_LEAD_QUERY = 'openLead'

export function leadDeepLinkPath(leadId: string): string {
  const params = new URLSearchParams()
  params.set(OPEN_LEAD_QUERY, leadId)
  return `/admin/lead-management?${params.toString()}`
}

/** Lead id from `?openLead=` or the older `#lead-` hash. */
export function leadIdFromLocation(search: string, hash: string): string | null {
  const fromQuery = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
    .get(OPEN_LEAD_QUERY)
    ?.trim()
  if (fromQuery) return fromQuery
  if (hash.startsWith('#lead-')) {
    const id = decodeURIComponent(hash.slice('#lead-'.length)).trim()
    return id || null
  }
  return null
}
